// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1jJOn","right":"styles_right__j3lyH"};